<template>
  <div class="xywcqk_content">
    <van-sticky :offset-top="95">
      <div class="executePlan_select">
        <div class="sem-drop">
          <div @click="showPicker2 = true">
            <template v-if="specliSchool">
              <p>{{ kcmxIndex.value2 || "院系名称" }}</p>
            </template>
            <template v-else>
              <p>{{ value2 || "院系名称" }}</p>
            </template>
            <i></i>
          </div>
        </div>
        <div class="sem-drop">
          <div @click="showPicker1 = true">
            <template v-if="specliSchool">
              <p>{{ kcmxIndex.value1 || "所在年级" }}</p>
            </template>
            <template v-else>
              <p>{{ value1 || "所在年级" }}</p>
            </template>
            <i></i>
          </div>
        </div>
        <div class="sem-drop">
          <div @click="fn4">
            <template v-if="specliSchool">
              <p>{{ kcmxIndex.value3 || "专业名称" }}</p>
            </template>
            <template v-else>
              <p>{{ value3 || "专业名称" }}</p>
            </template>
            <i></i>
          </div>
        </div>
        <div class="sem-drop">
          <div @click="fn5">
            <template v-if="specliSchool">
              <p>{{ kcmxIndex.value4 || "教学计划" }}</p>
            </template>
            <template v-else>
              <p>{{ value4 || "教学计划" }}</p>
            </template>
            <i></i>
          </div>
        </div>
      </div>
    </van-sticky>
    <van-popup v-model="showPicker2" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns2"
        @cancel="showPicker2 = false"
        @confirm="onConfirm2"
        :item-height="35"
      />
    </van-popup>
    <van-popup v-model="showPicker1" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns1"
        @cancel="showPicker1 = false"
        @confirm="onConfirm1"
        :item-height="35"
      />
    </van-popup>
    <van-popup v-model="showPicker3" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns3"
        @cancel="showPicker3 = false"
        @confirm="onConfirm3"
        :item-height="35"
      />
    </van-popup>
    <van-popup v-model="showPicker4" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns4"
        @cancel="showPicker4 = false"
        @confirm="onConfirm4"
        :item-height="35"
      />
    </van-popup>
    <NOdata v-if="tableData.length == 0 && isLoad" title="暂无数据~"></NOdata>
    <div v-else class="qz-list">
      <div
        class="qz-list-item"
        v-for="(item, index) in tableData"
        :key="index"
        @click="goDetail(item)"
      >
        <div class="qz-list-item-content">
          <img class="qz-list-item-icon" src="@/assets/images/jsb.png" alt="" />
          <div class="qz-list-item-text">
            <h4 class="qz-list-item-title">{{ item.kctxmc }}</h4>
            <p class="qz-list-item-label">要求学分：{{ item.xf }}</p>
          </div>
          <p class="qz-list-item-link">详情<van-icon name="arrow" /></p>
        </div>
      </div>
    </div>
    <van-popup
      v-model="show"
      :style="{ height: '100%', width: '100%' }"
      closeable
    >
      <h3 style="margin: 15px 0 0 16px; color: #505d9c">学分要求详情</h3>
      <NOdata v-if="popInfo.length == 0" title="暂无数据~"></NOdata>
      <div v-else class="xfyq-info">
        <div
          class="executePlan_list"
          v-for="(item, index) in popInfo"
          :key="index"
        >
          <template v-if="item.xfyqid == 'cxcyxfyq'">
            <h4>{{ item.xmmc }}</h4>
            <p>项目编号: {{ item.xmbh }}</p>
            <p>学期: {{ item.sj }}</p>
            <p>学分: {{ item.xf }}</p>
          </template>
          <template v-else>
            <h4>{{ item.kcmc }}</h4>
            <p>课程编号: {{ item.kch }}</p>
            <p>课程性质: {{ item.kcxz }}</p>
            <div>
              <div>
                <p>学分： {{ item.xf }}</p>
              </div>
              <div>
                <p>学时： {{ item.zxs }}</p>
              </div>
            </div>
            <p>是否计划内： {{ "是" }}</p>
          </template>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";

export default {
  inject: ['kcmxIndex'],
  data() {
    return {
      tableData: [],
      isLoad: true,
      show: false,
      popInfo: [],
      grade: [], //年级
      value1: "", //年级
      academy: [], //院系
      value2: "", //院系
      major: [], //专业
      value3: "", //专业
      showPicker1: false,
      show1: false,
      columns1: [
        {
          values: [],
          className: "column1",
        },
      ],
      showPicker2: false,
      columns2: [
        {
          values: [],
          className: "column1",
        },
      ],
      columns4: [],
      columns4_id: [],
      pyfa: "",
      yxmc: "",
      academyId: [],
      showPicker3: false,
      showPicker4: false,
      columns3: [],
      zymc: "",
      majorId: [],
      value4: "",
      schoolCode:'',
      specliSchool: false
    };
  },
  created() {
    this.schoolCode=+sessionStorage.getItem('schoolCode')
    this.specliSchool = [10008].includes(this.schoolCode)

    this.getGrade();
    //院系名称
    this.getAcademy();
    if (!this.specliSchool) return
    this.value1 = this.kcmxIndex.value1;
    this.value2 = this.kcmxIndex.value2;
    this.value3 = this.kcmxIndex.value3;
    this.value4 = this.kcmxIndex.value4;
    this.yxmc = this.kcmxIndex.yxmc;
    this.zymc= this.kcmxIndex.zymc;
    this.pyfa= this.kcmxIndex.pyfa;
    if(this.value1 && this.value2 && this.value3 && this.value4){
      console.log('111111111')
      this.getList();
    }
  },
  methods: {
    //所在年级
    onConfirm1(value1) {
      if (this.specliSchool) {
        this.kcmxIndex.value3 = "";
        this.kcmxIndex.value4 = "";
        this.kcmxIndex.value1 = value1.toString()
        this.kcmxIndex.zymc = "";
        this.kcmxIndex.pyfa = "";
      }
      this.value3 = "";
      this.zymc = "";
      this.value4 = "";
      this.pyfa = "";
      this.value1 = value1.toString();
      this.showPicker1 = false;
      this.getMajor();
    },
    async getMajor() {
      //专业名称
      let concatList3 = [];
      let concatList4 = [];
      const params = {
        academyId: this.yxmc,
        grade: this.value1,
      };
      const res = await Api.getAnnualMajorList(params);
      for (let i = 0; i < res.data.length; i++) {
        concatList3 = concatList3.concat(res.data[i].annumajorName);
        concatList4 = concatList4.concat(res.data[i].annumajorId);
      }
      this.columns3 = concatList3;
      this.majorId = concatList4;
    },
    //院系名称
    onConfirm2(value2, index) {
      if (this.specliSchool) {
        this.kcmxIndex.value3 = "";
        this.kcmxIndex.value4 = "";
        this.kcmxIndex.value2 = value2.toString()
        this.kcmxIndex.zymc = "";
        this.kcmxIndex.pyfa = "";
        this.kcmxIndex.yxmc = this.academyId[index];
      }
      this.value3 = "";
      this.zymc = "";
      this.value4 = "";
      this.pyfa = "";
      this.value2 = value2.toString();
      this.yxmc = this.academyId[index];
      this.showPicker2 = false;
      this.getMajor();
    },
    //专业名称
    onConfirm3(value3, index) {
      if (this.specliSchool) {
        this.kcmxIndex.value4 = "";
        this.kcmxIndex.value3 = value3.toString()
        this.kcmxIndex.zymc = this.majorId[index];
        this.kcmxIndex.pyfa = ""
      }
      this.value3 = value3.toString();
      this.zymc = this.majorId[index];
      this.value4 = ""
      this.pyfa = ""
      this.showPicker3 = false;
      this.getPyfa();
    },
    onConfirm4(value, index) {
      if (this.specliSchool) {
        this.kcmxIndex.value4 = value.toString()
        this.kcmxIndex.pyfa = this.columns4_id[index];
      }
      this.value4 = value.toString();
      this.pyfa = this.columns4_id[index];
      this.showPicker4 = false;
      this.getList();
    },
    async getPyfa() {
      if (!this.zymc) {
        return this.$toast("请先选择专业");
      }
      const params = {
        academyId: this.yxmc,
        majorId: this.zymc,
        gardeId: this.value1,
        type: '2'
      };
      const res = await Api.pyfalist(params);
      if (res.data) {
        this.columns4 = res.data.map((e) => e.pyfamc);
        this.columns4_id = res.data.map((e) => e.jx0301id);
      }
    },
    fn4() {
      if (this.value1 == "") {
        this.$toast("请先选择年级");
      } else if (this.columns3.length == 0) {
        this.$toast("未查询到专业信息~");
      } else {
        this.showPicker3 = true;
      }
    },
    fn5() {
      if (this.zymc == "") {
        this.$toast("请先选择专业");
      } else {
        this.showPicker4 = true;
      }
    },
    async getGrade() {
      let concatList1 = [];
      const params = {
        semester: "",
      };
      const res = await Api.getGradeList(params);
      for (let i = 0; i < res.data.length; i++) {
        concatList1 = concatList1.concat(res.data[i].gradeName);
      }
      this.columns1[0].values = concatList1;
    },
    async getAcademy() {
      let concatList2 = [];
      let concatList5 = [];
      const res = await Api.getAcademyList();
      for (let i = 0; i < res.data.length; i++) {
        concatList2 = concatList2.concat(res.data[i].academyName);
        concatList5 = concatList5.concat(res.data[i].academyId);
      }
      this.columns2[0].values = concatList2;
      this.academyId = concatList5;
    },
    async getList() {
      console.log('23234234')
      this.isLoad = false;
      const res = await Api.pyfakctxxfyq({jx01ndid: this.zymc, jx0301id: this.pyfa });
      this.tableData = res.data;
      this.isLoad = true;
    },
    async goDetail(item) {
      // console.log(item.jxp01kctxid, "item");
      const res = await Api.pyfakctxkcxx({jxp01kctxid: item.jxp01kctxid, jx0301id: this.pyfa });
      this.popInfo = res.data;
      this.show = true;
    },
  },
};
</script>

<style lang="less" scoped>
.xywcqk_content {
  // padding: 10px 0;
  .qz-list {
    padding: 0 15px 10px;
    background-color: #f2f2f4;

    .qz-list-item {
      border-radius: 6px;
      margin-top: 10px;
      background-color: #fff;
      padding: 16px 15px;
      line-height: 20px;

      .qz-list-item-content {
        display: flex;
        align-items: center;
        position: relative;

        .qz-list-item-icon {
          width: 40px;
          height: 40px;
        }

        .qz-list-item-text {
          margin-left: 9px;

          .qz-list-item-title {
            font-size: 16px;
            color: #333333;
            line-height: 22px;
          }

          .qz-list-item-label {
            font-size: 14px;
            color: #999999;
            font-weight: Medium;
            margin-top: 6px;
            line-height: 20px;
          }
        }

        .qz-list-item-link {
          color: @attendance-background-color-1;
          font-size: 14px;
          position: absolute;
          right: 0;
          display: flex;
          align-items: center;
        }
      }
    }
  }
  .van-popup {
    background-color: #f2f2f4;
  }
  .xfyq-info {
    box-sizing: border-box;
    padding: 0px 15px 0;
    height: 95%;
    overflow-y: scroll;
    .executePlan_list {
      width: 100%;
      box-sizing: border-box;
      padding: 20px;
      background: #fff;
      display: flex;
      flex-direction: column;
      border-radius: 5px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      &:first-of-type {
        margin-top: 10px;
      }
      > div {
        display: flex;
        justify-content: space-between;
        width: 100%;
        > div {
          width: 45%;
        }
      }
      h4 {
        text-align: left;
        margin-bottom: 4px;
        color: @attendance-color-8;
        font-size: 16px;
        line-height: 22px;
      }
      p {
        color: @attendance-color-2;
        font-size: 12px;
        line-height: 17px;
        margin-bottom: 2px;
      }
    }
  }
  .executePlan_select {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #fff;
    // border-bottom: 1px solid @attendance-border-color-6;
    .sem-drop {
      max-width: 25%;
      > div {
        display: flex;
        align-items: center;
        color: @attendance-color-2;
        font-size: 14px;
        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        i {
          background: url(../../../../../static/img/Triangle.png) no-repeat
            center;
          width: 20px;
          height: 10px;
          background-size: 10px 8px;
          // margin-left: 5px;
        }
      }
    }
    select {
      background: none;
      border: 0;
      outline: 0;
    }
    /deep/.van-ellipsis.van-picker-column__item.van-picker-column__item--selected {
      color: @attendance-color-1;
      font-weight: 600;
    }
    /deep/.van-dropdown-menu__title--active {
      color: @attendance-color-2;
    }
    /deep/.van-popup {
      max-height: 40%;
    }
    /deep/.van-hairline--top-bottom:after,
    .van-hairline-unset--top-bottom:after {
      border-width: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/train/xfyq.vue